/** @jsx jsx */
import { css, jsx } from '@emotion/react';

import * as React from 'react';

import { FloatingTooltip } from '@coursera-web/cds-labs';

import { ButtonBase, Typography2 } from '@coursera/cds-core';
import { CloseIcon } from '@coursera/cds-icons';

import _t from 'i18n!nls/cml';

type Props = React.PropsWithChildren<{
  show: boolean;
  onDismiss: () => void;
}>;

const styles = {
  tooltip: css`
    max-width: 240px;
  `,
  label: css`
    text-align: left;
    margin: var(--cds-spacing-150);
  `,
  title: css`
    margin-bottom: var(--cds-spacing-100);
  `,
  closeButton: css`
    position: absolute;
    top: var(--cds-spacing-50);
    right: var(--cds-spacing-50);
  `,
};

const AILayoutDiscoveryTooltip = ({ show, onDismiss, children }: Props) => {
  return (
    <FloatingTooltip
      show={show}
      message={
        <div>
          <div css={styles.label}>
            <Typography2 css={styles.title} color="invertBody" component="p" variant="subtitleMedium">
              {_t('Auto-layout now available')}
            </Typography2>
            <Typography2 color="invertBody" component="p" variant="bodySecondary">
              {_t('Engage learners by improving the layout of your Reading using the power of AI!')}
            </Typography2>
          </div>
          <ButtonBase onClick={onDismiss} aria-label={_t('Dismiss')} css={styles.closeButton}>
            <CloseIcon />
          </ButtonBase>
        </div>
      }
      trigger="controlled"
      placement="bottom"
      offset={4}
      css={styles.tooltip}
    >
      {children}
    </FloatingTooltip>
  );
};

export default AILayoutDiscoveryTooltip;
